export const environment = {
  production: true,
  rapi: 'https://api.ltsnhelp.com',
  multisite: {
    name: '1usd-cash4life',
    view: '.offer-product',
    apiresources: 'https://d3tmfelegj51yl.cloudfront.net/landings/offer-product/language/cash4life/',
    defaultLang: { lenid: 'en', lennombre: 'English' },
    langs: [
      { lenid: 'en', lennombre: 'English' },
      { lenid: 'es', lennombre: 'Español' },
      { lenid: 'pt', lennombre: 'Portugues' }
    ]
  },
  sentry: {
    dsn: 'https://8122d2bf17a14a61b01885af3a9f4e90@sentry.io/5029794',
    reportDialog: false,
    enable: false,
    logs: false
  },
  environment: '1usd-cash4life.prod',
  version: '1.0',
  lottery: {
    lot_id: 48,
    pcode: {
      wt: 'PCASH4LIFE1USD',
      ltk: 'PCASH4LIFE1USDLTK'
    },
    type: 'nxnoffer',
    synd_prc_code: {
      wt: 0,
      ltk: 0
    },
    offer: {
      base: 1,
      multiplier: 1,
      picks: {
        count: 5,
        from: 1,
        to: 60
      },
      extra_picks: {
        count: 1,
        from: 1,
        to: 4
      }
    }
  },
  pcode: {
    wt: 'PCASH4LIFE1USD',
    ltk: 'PCASH4LIFE1USDLTK'
  },
  type: 'discount-product',
  product_type: 1,
  product_id: 48,
  pick_type: 3,
  source: 'ng-1usd-cash4life',
  domainRestriction: null,
  upsellPage: null,
  promoSyndicate: false,
  templateIdPromoWT: 150,
  templateIdPromoLTK: 151,
  AES_CODE: '0PC0s9#MrgPHaJHi'
};
